var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.item.css || 'container mx-auto mb-24 lg:px-36',domProps:{"innerHTML":_vm._s(_vm.item.text.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }